<template>
  <div>
    <v-dialog v-model="dialog" max-width="600" scrollable>
      <template v-slot:activator="{ on, attrs }">
        <v-btn text x-small color="primary" dark v-bind="attrs" v-on="on">
          {{ btnText }}
        </v-btn>
      </template>
      <v-card color="white">
        <v-card-title class="d-flex flex-row orangeCardTitle">
          <div>Alternatives Keratometry Values</div>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon small
            ><v-icon color="primary" small>mdi-close</v-icon></v-btn
          >
        </v-card-title>

        <v-card-text class="pt-4 darkerCardText text-center">
          <b>Are any of these the values you were looking for?</b>
          <div class="caption">Click the correct Keratometry for each eye.</div>

          <div class="d-inline-block">
            <table class="borderedTable my-4 mx-2" style="min-width: 300px">
              <tr>
                <th class="overline odHeaderBackground">OD K</th>
                <td class="overline" style="background-color: #f6feff">Rx</td>
                <th class="overline osHeaderBackground">OS K</th>
              </tr>
              <tr>
                <td class="odBackground">
                  <input
                    type="radio"
                    v-model="selectionIndex.od"
                    :value="null"
                  />
                </td>
                <th>No Keratometry</th>
                <td class="osBackground">
                  <input
                    type="radio"
                    v-model="selectionIndex.os"
                    :value="null"
                  />
                </td>
              </tr>
              <tr v-for="(k, i) in kAlternatives" :key="i">
                <td class="odBackground">
                  <input type="radio" v-model="selectionIndex.od" :value="i" />
                </td>
                <th>
                  {{ k.string }}
                </th>
                <td class="osBackground">
                  <input type="radio" v-model="selectionIndex.os" :value="i" />
                </td>
              </tr>
            </table>
            <div class="">
              <!-- <v-spacer></v-spacer> -->
              <v-btn
                @click="emitRxs()"
                color="primary"
                small
                depressed
                :disabled="
                  selectionIndex.od === null && !selectionIndex.os === null
                "
              >
                Use Selected Keratometry</v-btn
              >
            </div>
          </div>
          <v-divider class="my-2"></v-divider>
          <div v-if="kText" class="mt-3">
            <div>
              <b>OR, If none of the above are correct..</b>
              <div class="caption">
                Review the text below. Can it be cleaned up? Is there any
                extraneous data (perhaps numbers for prism, VAs, PDs, etc) that
                may be confusing me?
              </div>
            </div>
            <v-textarea
              v-model="newText"
              outlined
              placeholder="Type or paste something to search for"
              clearable
              @keyup="edited = true"
            ></v-textarea>
            <v-btn
              :disabled="!edited"
              depressed
              small
              color="primary"
              @click="emitNewText()"
              >Search</v-btn
            >
          </div>

          <!-- <v-btn @click="dialog = false" small depressed outlined>Cancel</v-btn> -->
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import RxMethods from "@/assets/js/cls/RxMethods";
// import RxFormatted from "@/components/clStuff/RxFormatted";

export default {
  name: "KParserAlternatives",
  components: {
    // RxFormatted,
  },
  mixins: [RxMethods],
  props: {
    open: null,
    kText: null,
    kAlternatives: null,
    btnText: {
      type: String,
      default: "Is this the wrong Keratometry?",
    },
  },
  data: function () {
    return {
      dialog: false,
      newText: null,
      edited: false,
      // selection: { od: null, os: null },
      selectionIndex: { od: 0, os: 1 },
      //    localRxText: null,
    };
  },
  methods: {
    emitRxs() {
      let rtn = { od: null, os: null };
      ["od", "os"].forEach((eye) => {
        let kAltIndex = this.selectionIndex[eye];
        if (kAltIndex === null) {
          rtn[eye] = null;
        } else {
          rtn[eye] = this.kAlternatives[kAltIndex];
        }
      });

      this.$emit("newKs", rtn);
      // console.log("emitted", rtn);
      this.dialog = false;
    },
    emitNewText() {
      this.$emit("newText", this.newText);
      this.dialog = false;
    },
  },
  computed: {},
  mounted() {
    this.newText = this.kText;
    // this.localRxText = this.rxText;
  },
};
</script>

<style scoped>
.blue {
  background-color: rgb(230, 239, 255) !important;
}

input[type="radio"] {
  transform: scale(1.5);
}

table {
  border-spacing: 0;
  border-collapse: collapse;
}
table td,
table th {
  border: 1px solid #ddd;
  padding: 4px 8px;
  text-align: center;
}
</style>
